export const getVotedAnswer = (votedId, allAnswers) =>
  ((allAnswers || []).filter(({ answerId }) => answerId === votedId)[0] || {}).answerText || '';

/* it's used to get percentage of each rate answer + map its text by slug */
export const mapResultsWithAnswers = (totalRate, results, answers) => {
  const rawResults = [...results];
  const answersTextsDict = {};
  answers.forEach(({ answerId, answerText }) => {
    answersTextsDict[answerId] = answerText;
  });
  // ===
  const mappedData = {};
  rawResults
    .sort((curr, next) => curr.rate - next.rate)
    .reduce((restPercentage, { answerId, rate }) => {
      let percentRate = Math.round((rate / totalRate) * 100);
      if (rate !== 0 && percentRate === 0) {
        percentRate += 1;
      }
      if (percentRate > restPercentage) percentRate = restPercentage;
      mappedData[answerId] = {
        answerId,
        answerText: answersTextsDict[answerId],
        rate,
        percentRate,
      };
      return restPercentage - percentRate;
    }, 100);
  return results.map(({ answerId }) => ({ ...mappedData[answerId] }));
};
